import { validateIsAfter } from 'uplisting-frontend/validators/is-after';
import { validateIsBefore } from 'uplisting-frontend/validators/is-before';

export const UnavailabilityValidation = {
  from: validateIsBefore('to'),
  to: validateIsAfter('from'),
};
